// import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { pl } from 'vuetify/locale'

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  icons: {
    aliases: {
      expand: 'mdi-arrow-down',
      collapse: 'mdi-arrow-up',
    },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#eade5e',
        },
      },
    },
  },
  locale: {
    locale: 'pl',
    messages: { pl },
  },
})
